export enum CTMWorkOrderViewType {

  Standard = 5,
  Quotation = 10

}
